<template>
  <div id="photoForm" class="user-profile__add-photo">
    <div class="user-profile__add-photo__img">
      <img v-if="photoUrl" :src="photoUrl" alt="фотография профиля">
      <img v-else src="@/assets/img/photo-add.svg" alt="фотография профиля">
    </div>
    <form ref="profilePhotoForm" @submit.stop.prevent="submitProfilePhotoForm" novalidate="true">
      <input
        aria-label="Загрузить фото"
        ref="profilePhotoInput"
        type="file"
        accept="image/jpeg,image/png"
        @change="inputChange"
        style="display: none">
      <button
        type="button"
        v-on:click.prevent="addPhotoClick"
        class="user-profile__add-photo__button">
        <template v-if="!photoUrl">Добавить фото</template>
        <template v-else>Изменить фото</template>
      </button>
      <button
        v-if="photoUrl"
        type="button"
        v-on:click.prevent="isShowDeletePhotoDialog = true"
        class="user-profile__add-photo__button">
        Удалить фото
      </button>
    </form>
    <modal-dialog
      title="Вы точно хотите удалить категорию?"
      v-model="isShowDeletePhotoDialog"
      v-bind:with-cross="true"
    >
      <confirm-modal
        confirm-title="Удалить"
        cancel-title="Отмена"
        v-on:on-confirm="delPhotoClick"
        v-on:on-cancel="isShowDeletePhotoDialog = false"
      />
    </modal-dialog>
  </div>
</template>

<script>
import ModalDialog from '@/components/ModalDialog.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

export default {
  name: 'FormProfilePhoto',
  components: {
    ConfirmModal,
    ModalDialog,
  },
  props: ['photoUrl'],
  data() {
    return {
      /**
       * @description Показывать ли диалоговое окно удаления фотографии профиля.
       * @type {boolean}
       */
      isShowDeletePhotoDialog: false,
      /**
       * @description загруженный файл
       * @type {File}
       */
      image: null,
    };
  },
  methods: {
    /**
     * Событие выбора файла
     * @param event
     */
    inputChange(event) {
      const file = event.target.files[0];
      this.image = file;
      this.$refs.profilePhotoForm.dispatchEvent(new Event('submit', { cancelable: true }));
    },
    /**
     * Событие при сабмите формы
     */
    submitProfilePhotoForm() {
      const imageData = {
        file: this.image,
      };
      this.$emit('form-submit', imageData);
    },
    /**
     * нажатие на кнопку добавления фото
     */
    addPhotoClick() {
      this.$refs.profilePhotoInput.click();
    },
    /**
     * нажатие на кнопку удалить фото
     */
    delPhotoClick() {
      this.isShowDeletePhotoDialog = false;
      this.$emit('delete-photo');
    },
  },
};
</script>

<style scoped lang="scss">
.user-profile {
  &__add-photo {
    &__img {
      display: flex;
      justify-content: center;
      width: 177px;
      height: 177px;
      img {
        width: 177px;
        height: 177px;
        object-position: center;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    &__button {
      width: 100%;
      max-width: 177px;
      margin: 20px 0 0 0;
      height: 48px;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-family: "Lato", sans-serif;
      border: 1px solid #0489E0;
      background-color: #FFFFFF;
      color: #0489E0;
      transition: all 0.3s ease 0s;
      cursor: pointer;
      &:hover {
        border: 1px solid #0076C3;
        color: #0076C3;
        transition: all 0.3s ease 0s;
      }
    }
  }
}
</style>
